import { UserFormGroup } from '../../../models/forms/UserFormGroup';
import { IGenericBaryFormGroup } from '../../../models/forms/GenericBaryFormGroup';
import { BaryUserControls } from '../../../models/forms/builder/BaryUserFormBuilder';

export class UserMapper {
  static extractFromBaryForm(baryForm: UserFormGroup): any {
    const object: any = Object.create({});
    const userForm = baryForm.controls.userForm as IGenericBaryFormGroup<BaryUserControls>;
    object.civility = userForm.controls.civility.value;
    object.firstName = userForm.controls.firstName.value;
    object.lastName = userForm.controls.lastName.value;
    object.phone = userForm.controls.phone.value;
    object.email = userForm.controls.email.value;
    object.position = userForm.controls.position.value;
    object.dateBirth = userForm.controls.dateBirth.value;
    object.isTemporalPassword = userForm.controls.isTemporalPassword.value;

    if (baryForm?.companyForm?.value) {
      object.companyLegalStatus = baryForm.companyForm.controls['companyLegalStatus'].value;
      object.companyName = baryForm.companyForm.controls.companyName.value;
      object.vatNumber = baryForm.companyForm.controls.vatNumber.value;
      object.siret = baryForm.companyForm.controls.siret.value;
    } else {
      object.companyLegalStatus = baryForm.associationForm?.controls.companyLegalStatus.value;
      object.companyName = baryForm.associationForm?.controls.companyName.value;
      object.vatNumbeer = baryForm.associationForm?.controls.vatNumber.value;
      object.siret = baryForm.associationForm?.controls.siret.value;
    }

    object.companyAddressStreetNumber = baryForm.addressForm?.controls.streetNumber.value;
    object.companyAddressStreet = baryForm.addressForm?.controls.street.value;
    object.companyAddressFullname = baryForm.addressForm?.controls.fullname.value;
    object.companyAddressCity = baryForm.addressForm?.controls.city.value;
    object.companyAddressZipCode = baryForm.addressForm?.controls.zipCode.value;
    object.companyAddressCountry = baryForm.addressForm?.controls.country.value;
    object.companyAddressAdditionals = baryForm.addressForm?.controls.additionals.value;

    object.billAddressStreetNumber = baryForm.billAddressForm?.controls.streetNumber.value;
    object.billAddressStreet = baryForm.billAddressForm?.controls.street.value;
    object.billAddressFullname = baryForm.billAddressForm?.controls.fullname.value;
    object.billAddressCity = baryForm.billAddressForm?.controls.city.value;
    object.billAddressZipCode = baryForm.billAddressForm?.controls.zipCode.value;
    object.billAddressCountry = baryForm.billAddressForm?.controls.country.value;
    object.billAddressAdditionals = baryForm.billAddressForm?.controls.additionals.value;
    object.billEmail = baryForm.billAddressForm?.controls.billEmail.value;

    return object;
  }
}
